import "./header.css";
import { useState } from "react";
import { Menu, Close, ChevronRight, ChevronLeft } from "@material-ui/icons";
import discordImg from "../../assets/images/others/discord.svg";
import diamondImg from "../../assets/images/others/diamond.png";
//  =========== import your logo like this ================
import logo from "../../assets/images/others/logo_white_trans.png";
//
import insta from "assets/images/socialIcons/insta.gif";
import twitter from "assets/images/socialIcons/twitter.gif";
import telegram from "assets/images/socialIcons/telegram.gif";
import discord from "assets/images/socialIcons/discord.gif";
import openSeaIcon from "assets/images/socialIcons/openSeaIcon.png";

const Header = () => {
  const [sideBar, setSideBar] = useState(false);
  // go to the section
  const scrollTo_Section = (sec_id) => {
    let element = document.getElementById(sec_id);
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  return (
    <header className="web-header">
      <div className="row header-container">
        <div className="header-logo-area">
          <span className="logo-wraps" onClick={() => scrollTo_Section("hero")}>
            {/*================ logo image here =============================*/}
            <img
              className="header-main-logo"
              loading="lazy"
              src={logo}
              alt="WeStream"
            />
          </span>
        </div>
        <div className="header-right-area">
          {/* ============== Top right corner discord button ================ */}
          <a
            href="https://opensea.io/collection/westreamers-official"
            target="_blank"
            rel="noopener noreferrer"
            className="header-join-btn row"
          >
            OPENSEA NFTS
            <img loading="lazy" src={openSeaIcon} alt="" />
          </a>
          {/* <a
            href="https://discord.gg/WeStream"
            target="_blank"
            rel="noopener noreferrer"
            className="header-join-btn row"
          >
            Join Discord
            <img loading="lazy" src={discordImg} alt="" />
          </a> */}
          <div className="menu-btn">
            {sideBar ? (
              <Close onClick={() => setSideBar(false)} className="menu-icon" />
            ) : (
              <Menu onClick={() => setSideBar(true)} className="menu-icon" />
            )}
          </div>
        </div>
      </div>
      <div className="sidebar-open-btn" onClick={() => setSideBar(true)}>
        <ChevronLeft className="chev-icon" />
      </div>
      {sideBar && (
        <div
          onClick={() => setSideBar(false)}
          className="backdrop-sidebar"
        ></div>
      )}
      <nav className={`side-bar-wrapper ${sideBar ? "opened-sidebar" : ""}`}>
        <div className="side-logo row">
          {/*============== side logo image ===============*/}
          <img loading="lazy" src={logo} alt="WeStream" />
        </div>
        {/* ================= Sidebar links ======================== */}
        <ul>
          <li>
            <button
              className="nav-links"
              onClick={() => {
                setSideBar(false);
                scrollTo_Section("hero");
              }}
            >
              Home
            </button>
          </li>
          <li>
            <button
              className="nav-links"
              onClick={() => {
                setSideBar(false);
                scrollTo_Section("nft");
              }}
            >
              NFT Collection
            </button>
          </li>
          <li>
            <button
              className="nav-links"
              onClick={() => {
                setSideBar(false);
                scrollTo_Section("roadMap");
              }}
            >
              RoadMap
            </button>
          </li>
          <li>
            <button
              className="nav-links"
              onClick={() => {
                setSideBar(false);
                scrollTo_Section("features");
              }}
            >
              App Features
            </button>
          </li>
          <li>
            <button
              className="nav-links"
              onClick={() => {
                setSideBar(false);
                scrollTo_Section("token");
              }}
            >
              $STREAM Token
            </button>
          </li>
          <li>
            <button
              className="nav-links"
              onClick={() => {
                setSideBar(false);
                scrollTo_Section("whitePaper");
              }}
            >
              Whitepaper
            </button>
          </li>
          <li>
            <button
              className="nav-links"
              onClick={() => {
                setSideBar(false);
                scrollTo_Section("faq");
              }}
            >
              FAQS
            </button>
          </li>
          <li>
            <button
              className="nav-links"
              onClick={() => {
                setSideBar(false);
                scrollTo_Section("team");
              }}
            >
              Team
            </button>
          </li>
          <li>
            <button
              className="nav-links"
              onClick={() => {
                setSideBar(false);
                scrollTo_Section("discord");
              }}
            >
              Community
            </button>
          </li>
          <li>
            <a
              href="https://opensea.io/collection/westreamers-official"
              target="_blank"
              rel="noopener noreferrer"
              className="header-join-btn row"
            >
              OPENSEA NFTS
              <img loading="lazy" src={openSeaIcon} alt="" />
            </a>
          </li>
        </ul>
        <div className="social sidebar-socials row">
          {/* ====================== SideBar Social Links ========================= */}
          <div className="link">
            <a
              href="https://instagram.com/WeStreamApp"
              target="_blank"
              rel="noopener noreferrer"
              className="insta row"
            >
              <img src={insta} alt="" />
            </a>
          </div>
          <div className="link">
            <a
              href="https://t.me/WeStream"
              target="_blank"
              rel="noopener noreferrer"
              className="tele row"
            >
              <img src={telegram} alt="" />
            </a>
          </div>
          <div className="link">
            <a
              href="https://twitter.com/WeStreamApp"
              target="_blank"
              rel="noopener noreferrer"
              className="twitter row"
            >
              <img src={twitter} alt="" />
            </a>
          </div>
          <div className="link">
            <a
              href="https://discord.gg/WeStream"
              target="_blank"
              rel="noopener noreferrer"
              className="discord row"
            >
              <img src={discord} alt="" />
            </a>
          </div>
        </div>
        <div className="sidebar-close-btn" onClick={() => setSideBar(false)}>
          <ChevronRight className="chev-icon" />
        </div>
      </nav>
    </header>
  );
};

export default Header;
